import React from 'react'
import type { Place } from '../../types/place'

import Exhibition from '../places/Exhibition'
import Station from '../places/Station'
import { useAppSelector } from '../../redux/hooks';
import { selectCurrentLayout } from '../../redux/selectors';
import WideImage from '../thumbnails/WideImage'
import RoundImage from '../thumbnails/RoundImage'
import WalkingTour from '../thumbnails/WalkingTour'

interface ThumbnailProps {
  props: Place;
  enabled?: boolean;
  wasViewed?: boolean;
}

const Thumbnail: React.FC<ThumbnailProps> = ({props, enabled, wasViewed}) => {
  const currentLayout = useAppSelector(selectCurrentLayout)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let ThumbnailType: React.ComponentType<any> | undefined
  let formattedProps: Record<string, unknown> = {...props}

  switch (currentLayout) {
    case 'round_image_card': 
      formattedProps = {
        description: props.translations[0].information_short_description,
        id: props.id,
        img: props.information_photo,
        title: props.translations[0].information_title 
      }
      ThumbnailType =  RoundImage
      break
    case "wide_image_title_description":
      ThumbnailType = Exhibition
      break
    case "side_image_title_description":
      formattedProps = { place: props }
      ThumbnailType = Station
      break
    case "wide_image_title":
      formattedProps = {
        img: props.information_photo,
        type: props.type,
        height: '20vh', 
        text: props?.translations[0].information_title,
        id: props.id,
        status: props.status,
      }
      ThumbnailType = WideImage
      break
    case "short_image_title":
      formattedProps = {
        img: props.information_photo,
        type: props.type,
        height: '15vh',
        text: props?.translations[0]?.information_title,
        id: props.id,
      }
      ThumbnailType = WideImage
      break
    case "walking_tour":
      formattedProps = {
        title: props.translations[0].information_title,
        subtitle: props.translations[0].information_subtitle,
        shortDescription: props.translations[0].information_short_description,
        date: props.translations[0].information_date,
        photo: props.information_photo,
        type: props.type,
        id: props.id,
        enabled: enabled,
        wasViewed: wasViewed,
        iconId: props.information_icon?.id,
        thumbnailType: props.thumbnail_type,
        address: props.translations[0].information_address
      }
      ThumbnailType = WalkingTour
      break
    default:
      break;
  }

  return (
    <div className="thumbnail" 
      style={{
        display: 'contents',
      }} 
      >
      {ThumbnailType && <ThumbnailType  {...formattedProps}/>}
    </div>
  )


}


export default Thumbnail
